import { firstNameFirst } from './staffName.ts';

/**
 * What the header says about who is signed in (Arthur, 19 October 2026): the name, first name first, and under it
 * the primary role's display name as the job title; the name line becomes the username while asked for (hover,
 * keyboard focus, a tap). The username is the address without the agency's domain ("a.rennard" for a.rennard@alliedcss.org); an account on any
 * other domain (breakglass@...onmicrosoft.com) shows its whole address, so it is never mistaken for an agency one.
 * The accessible name and the hover text always hold everything, so a screen reader never depends on the swap and a
 * line cut short by the width is still readable. A leaf module, tested in web/test/account-badge.test.ts.
 */
export interface BadgeMe { fullName: string; email: string; role: { name: string } }

export const AGENCY_DOMAIN = 'alliedcss.org';

/** The address without the agency's domain; any other address whole. */
export function username(email: string): string {
  const at = email.lastIndexOf('@');
  if (at > 0 && email.slice(at + 1).trim().toLowerCase() === AGENCY_DOMAIN) return email.slice(0, at);
  return email;
}

export interface BadgeLines {
  name: string;
  handle: string;
  title: string | null;
  label: string;
  tooltip: string;
}

export function badgeLines(me: BadgeMe): BadgeLines {
  const name = firstNameFirst(me.fullName);
  // An account named for its role ("System Administrator", Arthur, 19 October) would say it twice: no title line then.
  const same = name.trim().toLowerCase() === me.role.name.trim().toLowerCase();
  const title = same ? null : me.role.name;
  const all = title ? `${name}, ${title}, ${me.email}` : `${name}, ${me.email}`;
  return { name, handle: username(me.email), title, label: `Signed in as ${all}`, tooltip: all };
}
